import React, {useEffect, useRef, useState} from "react";
import AcceptDenyModal from "./AcceptDenyModal";
import LobbyCard from "./LobbyCard";
import socket from "../utils/clientSocket";
import {gameState} from "./Game";
import {useNavigate} from "react-router-dom";

const FriendChallenges = () => {
    const [ownChallenge, setOwnChallenge] = useState(null)
    const [friendChallenges, setFriendChallenges] = useState([])
    const [showCancelOffer, setShowCancelOffer] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const [offerBeingConsidered, setOfferBeingConsidered] = useState(null)
    //This may also seem like double work, but the ref guarantees we are looking at something up to date
    const acceptedOfferIds = useRef([])

    const navigate = useNavigate()

    const showErrorMessage = (errorMessage) => {
        setErrorMessage(errorMessage);
        setTimeout(() => {
            setErrorMessage(null)
        }, 3000)
    }

    useEffect(() => {
        socket.on("friendChallengeCreated", ({offer, isSuccessful}) => {
            if(!isSuccessful) {
                showErrorMessage("Challenge failed - friend is offline.")
                return;
            }
            setOwnChallenge(offer)
        });

        socket.on("friendChallengeReceived", (offer) => {
            setFriendChallenges((prevChallenges) => [...prevChallenges, offer])
        })

        socket.on("gameStarted", ({gameId, gameLength, isWhite, fen, initialFen, currentTurn, eloDeltas, moves, opponent}) => {
            console.log("Game started with ID:", gameId);
            const state = {}
            state.gameId = gameId;
            state.fen = fen;
            state.initialFen = initialFen;
            state.gameLength = gameLength
            state.gameState = gameState.IN_PROGRESS;
            state.currentTurn = currentTurn;
            state.eloDeltas = eloDeltas;
            state.moves = moves;
            state.opponent = opponent;


            // Determine if the current socket/player is white
            state.orientation = isWhite ? "white" : "black";
            state.color = isWhite ? "w" : "b";
            navigate("/play", {state: state})
        });

        return () => {
            socket.off("friendChallengeCreated");
            socket.off("friendChallengeReceived");
            socket.off("gameStarted");
        }
    }, []);

    useEffect(() => {
        socket.on("friendChallengeRemoved", (offerId) => {
            if(ownChallenge?.offerId === offerId) {
                setOwnChallenge(null)
            } else {
                setFriendChallenges((prevChallenges) => prevChallenges.filter(challenge => challenge.offerId !== offerId))
            }
        });

        return () => socket.off("friendChallengeRemoved")
    }, [ownChallenge])

    const handleAcceptGame = (offer) => {
        if(acceptedOfferIds.current.find(a => a === offer.offerId)) {
            console.log("offer already accepted")
            return;
        }
        acceptedOfferIds.current.push(offer.offerId)
        socket.emit("acceptGameOffer", { offerId: offer.offerId });
        setFriendChallenges((prevState) => prevState.filter(o => o.offerId !== offer.offerId))
        setOfferBeingConsidered(null)
    };

    const cancelOffer = () => {
        socket.emit("cancelOffer");
        setShowCancelOffer(false);
        setOwnChallenge(null);
    }

    const denyFriendChallenge = (offer) => {
        setFriendChallenges((prevState) => prevState.filter(o => o.offerId !== offer.offerId))
        setOfferBeingConsidered(null)
        socket.emit("denyFriendChallenge", {offerId: offer.offerId})
    }

    return (
        <div style={{display: "flex", flexDirection: "column-reverse"}}>
            {errorMessage && <div className="info-message error"
                                  style={{marginTop: "0.5rem"}}>
                {errorMessage}
            </div>}
            {showCancelOffer && <div className="modal-overlay" onClick={() => setShowCancelOffer(false)}>
                <AcceptDenyModal statement={"Do you want to cancel your offer?"}
                                 denyCallback={() => setShowCancelOffer(false)}
                                 acceptCallback={cancelOffer} closeCallback={() => setShowCancelOffer(false)}
                style={{color: "#333"}}/>

            </div>}
            {offerBeingConsidered && <div className="modal-overlay" onClick={() => setOfferBeingConsidered(null)}>
                <AcceptDenyModal statement={"Accept challenge?"}
                                 denyCallback={() => denyFriendChallenge(offerBeingConsidered)}
                                 acceptCallback={() => handleAcceptGame(offerBeingConsidered)} closeCallback={() => setOfferBeingConsidered(null)}
                                 style={{color: "#333"}}/>

            </div>}
            {ownChallenge && <LobbyCard offer={ownChallenge} onClick={() => setShowCancelOffer(true)}
                                        style={{backgroundColor: "#bbb"}} isOwnOffer={true}/>}
            {friendChallenges.map((offer) => (
                <LobbyCard offer={offer} onClick={() => setOfferBeingConsidered(offer)} isOwnOffer={false} style={{marginBottom: "0.5rem"}}/>
            ))}
        </div>
    )
}

export default FriendChallenges;